import { COLORS } from 'Components/utils/color/colors';
import classnames from 'classnames';

const getNavPositionClasses = (navPosition, shouldFadeOut) => {
  switch (navPosition) {
    case 'bottom':
      return {
        thRoot: 'overflow-hidden relative rtl:text-right',
        thControls: 'inline-flex items-center mt-2 -mx-1',
        thControl: 'mx-1',
        thControlsWrapper: 'flex',
      };
    case 'side':
      return {
        thRoot: 'flex rtl:flex-row overflow-hidden relative',
        thControls: 'border-l-1 border-r-1 flex items-center px-1',
        thControl: 'mx-1',
      };
    case 'top':
      return {
        thRoot: 'flex flex-col',
        thControls: 'flex -mx-1 mb-2 rtl:ml-1',
        thControl: 'mx-1',
        thControlsWrapper: 'flex -order-1',
      };
    default:
    case 'center':
      return {
        thRoot: classnames('overflow-hidden relative', {
          'rtl:scrollableOverflowFadeOut-root': shouldFadeOut,
        }),
        thControls: classnames(
          'absolute flex items-center justify-between inset-0 pointer-events-none',
          { 'rtl:scrollableOverflowFadeOut-pin': shouldFadeOut },
          { 'w-full': !shouldFadeOut },
        ),
        thControl: 'mx-1',
        thControlDisabled: 'a11y-focusable',
        thControlLeft: 'pointer-events-auto mr-auto',
        thControlRight: 'pointer-events-auto ml-auto',
      };
  }
};

export const themes = {
  default: ({ navPosition, shouldFadeOut }) => {
    return {
      ...getNavPositionClasses(navPosition, shouldFadeOut),
      thControlColor: COLORS.WHITE,
      thControlColorBg: COLORS.BLUE,
    };
  },
};
